"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SkuStructFromSkuString = exports.CustomerFromCode = exports.ColorFromCode = exports.SizeFromCode = exports.MODELS = exports.ModelFromCode = void 0;
const effect_1 = require("effect");
const schema_1 = require("../../../../schema");
const Technology = __importStar(require("./technology"));
const Water = __importStar(require("./water"));
const NAMESPACE = 'Culligan.Device.Class.Gbfc.Sku';
exports.ModelFromCode = effect_1.Schema.transformLiterals(['GD', 'GBFC Good'], ['GDFX', 'GBFC Good + FX'], ['BRFX', 'GBFC Better + FX'], ['BR2FX', 'GBFC Better v2 + FX'], ['BR', 'GBFC Better'], ['BR2', 'GBFC Better v2'], ['BTFX', 'GBFC Best + FX']).annotations({
    identifier: `${NAMESPACE}.ModelFromCode`,
});
exports.MODELS = {
    Good: 'GBFC Good',
    GoodFx: 'GBFC Good + FX',
    Better: 'GBFC Better',
    BetterFx: 'GBFC Better + FX',
    BetterV2: 'GBFC Better v2',
    BetterV2Fx: 'GBFC Better v2 + FX',
    BestFx: 'GBFC Best + FX',
};
exports.SizeFromCode = effect_1.Schema.transformLiterals(['FS', 'Freestanding'], ['FT', 'Freestanding Tall'], ['M', 'Mini'], ['MU', 'Micro']).annotations({
    identifier: `${NAMESPACE}.SizeFromCode`,
});
exports.ColorFromCode = effect_1.Schema.transformLiterals(['BL', 'Black'], ['GR', 'Grey'], ['WH', 'White']).annotations({
    identifier: `${NAMESPACE}.ColorFromCode`,
});
exports.CustomerFromCode = effect_1.Schema.transformLiterals(['CUS', 'Culligan United States'], ['EDC', 'Culligan EMEA'], ['DE1', 'Culligan Germany'], ['LTM', 'LATAM'], ['MX1', 'Mexico'], ['BR1', 'Brazil'], ['WLK', 'Waterlogic UK'], ['WLU', 'Waterlogic USA']).annotations({
    identifier: `${NAMESPACE}.CustomerFromCode`,
});
exports.SkuStructFromSkuString = (0, schema_1.CapturePattern)(/^F-(?<model>\w+)-(?<size>\w+)-(?<waterTypes>\w+)-(?<technology>\w+)-(?<color>\w+)-(?<customer>\w+)$/, effect_1.Schema.Struct({
    model: exports.ModelFromCode,
    size: exports.SizeFromCode,
    waterTypes: Water.TypesFromOption,
    technology: Technology.TechnologyStructFromCode,
    color: exports.ColorFromCode,
    customer: exports.CustomerFromCode,
}), ({ model, size, waterTypes, technology, color, customer }) => effect_1.Effect.succeed(`F-${[model, size, waterTypes, technology, color, customer].join('-')}`)).annotations({
    identifier: `${NAMESPACE}.SkuStructFromSkuString`,
});
//# sourceMappingURL=sku.js.map